var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ad-image"},[_c('div',{staticClass:"w-100"},[_vm._t("picture")],2),(_vm.hasDescription)?_c('div',[_vm._t("figcaption")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }